import { ProductSearchStartPageHitV1 } from '@inditex/resellanl-ianalytics-events';
import { buildEvent } from '../helpers/build-event';
import { normalizeUniverse } from '../helpers/normalize-universe';

export const PRODUCT_SEARCH_START_PAGE_HIT = ({ data }: { data?: unknown }) => {
  const payload = data as {
    universe?: string;
  };

  const event = buildEvent({
    Event: ProductSearchStartPageHitV1,
    payload: {
      universe: normalizeUniverse(payload?.universe),
    },
  });

  return event;
};
